import type { LicenceResponse } from '@shared/schemas';

import type { SaveStatus } from '../../_shared/domain/user-draft.model';
import {
  type AddUserDraft,
  type AddValidationErrors,
  emptyAddDraft,
} from '../domain/add-user-draft.model';
import type { AddUserError } from '../domain/add-user-error';

/**
 * Redux state for the Add-user form: the editable draft, the licences available
 * for the picker, the preset licence id (when launched from a licence page), the
 * save lifecycle, the last business error, and per-field validation messages.
 * Every field is serialisable.
 */
export interface AddUserState {
  draft: AddUserDraft;
  licences: LicenceResponse[];
  presetLicenceId: string;
  saveStatus: SaveStatus;
  /** Once saved: who was created, and whether their invitation went out (#594). */
  created: CreatedUser | null;
  validationErrors: AddValidationErrors;
  error: AddUserError | null;
}

/** The outcome of a successful save: the user exists; the invitation may not have gone. */
export interface CreatedUser {
  email: string;
  invitationSent: boolean;
}

export const initialState: AddUserState = {
  draft: emptyAddDraft,
  licences: [],
  presetLicenceId: '',
  saveStatus: 'idle',
  created: null,
  validationErrors: {},
  error: null,
};
